<script>
	import { linkToAppointment, assetUrl, startTime, language, prefix, i18n, mainStep, resultsI18N, questions } from './stores.js';

    // import { onMount } from 'svelte';
	import { fade } from 'svelte/transition';
	import { quartIn } from 'svelte/easing';
	import Button from './Atoms/Button.svelte';
    import Icon from './Atoms/Icon.svelte';
	import DailyMedPack from './Molecules/DailyMedPack.svelte';
	import { onMount, onDestroy } from 'svelte';


	$: packs = $questions ? $questions[4].answers.filter((a) => { return a.selected === true; }) : [];
	$: time = $questions ? ($questions[0].answers.find((a)=>{return a.selected === true;})).value + ($questions[2].answers.find((a)=>{return a.selected === true;})).value : 0;
	$: value = $questions ? $questions[2].answers.find((a)=>{return a.selected===true;})["price_value"] : "0"; 
	$: isFree = value === "0,&ndash;"; 
	$: showNonblisterable = $questions && $questions[3].answers[0].selected === true;
	$: showAlternativeDeliveryImage = $questions && $questions[3].answers.find((a)=>{return a.selected===false;}).value === true;

	function ctaClicked() {
		window.open($linkToAppointment, '_blank').focus();
	}

	// onMount(() => {
	// 	console.log(showAlternativeDeliveryImage);
	// });

</script>

<div class="{$prefix}-animation-container" in:fade="{{duration: 1600, easing: quartIn}}" out:fade="{{duration: 800}}">
	<div class="{$prefix}-results-container">
		<!-- Ihr täglicher Bedarf -->
		<div class="{$prefix}-results-A">
			<div class="{$prefix}-results-A__headline-row">
				<span class="{$prefix}-results-heading">
					{$resultsI18N.dailyMedicationHeading }
				</span>
				<span class="{$prefix}-results-button">
					<Button buttonText="{$resultsI18N.button}" buttonClass="light" on:buttonClicked={ctaClicked} ></Button>
				</span>
			</div>
			<div class="{$prefix}-results-A__description">
				{@html $resultsI18N.dailyMedicationHTML }
			</div>
			<div class="{$prefix}-results-A__packs">
				{#each packs as pack}
					<div class="{$prefix}-results-A__pack">
						<img class="{$prefix}-results-A__pack__img" src="{$resultsI18N.timeImageFolder}{$language}/{pack.value}.svg" />
						<span class="{$prefix}-results-A__pack__text">{pack.text}</span>
					</div>
				{/each}
			</div>
		</div>
		<!-- nicht verblisterbaren Medikamenten -->
		{#if showNonblisterable}
		<div class="{$prefix}-results-D">
			<div class="{$prefix}-results-heading">{$resultsI18N.labelNonblisterableMeds}</div>
			<div class="{$prefix}-results-D__img">
				<img src="{$resultsI18N.nonBlisterableImgURL}" alt="" class="{$prefix}-row-img"/>
			</div>				

		</div>
		{/if}
		<!-- Zeit und Kosten -->
		<div class="{$prefix}-results-C">
			<div class="{$prefix}-results-C__group {$prefix}-results-C__group--left">
				<div class="{$prefix}-results-C__group__heading">
					<span class="{$prefix}-results-C__L">{time/60}</span>
					<span class="{$prefix}-results-C__M">{$resultsI18N.time}</span>
					<span class="{$prefix}-results-C__S">{$resultsI18N.saveTime}</span>
				</div>
				<div class="{$prefix}-results-C__group__description">
					{@html $resultsI18N.htmlTime}
				</div>
			</div>
			<div class="{$prefix}-results-C__group {$prefix}-results-C__group--right">
				<div class="{$prefix}-results-C__group__heading">
					<span class="{$prefix}-results-C__M">CHF</span>
					<span class="{$prefix}-results-C__L">{@html value}</span>
					<span class="{$prefix}-results-C__S">{isFree ? $resultsI18N.costFree : $resultsI18N.notCostFree}</span>
				</div>
				<div class="{$prefix}-results-C__group__description">
					{@html $resultsI18N.htmlCost}
				</div>
			</div>
		</div>
		<!-- Alle Medikamente in einer Box -->
		<div class="{$prefix}-results-B">
			{#if showAlternativeDeliveryImage} 
				<!-- Antwort NEIN -->
				<div class="{$prefix}-results-B__headline-row">
					<p class="{$prefix}-results-heading">{$resultsI18N.deliveryRowHeadingAlternative}</p>
					<p>{$resultsI18N.deliveryRowTextAlternative}</p>
				</div>
				<img class="{$prefix}-results-B__image" src="{$resultsI18N.deliveryRowImageAlternative}" />
			{:else}
				<!-- Antwort JA -->
				<div class="{$prefix}-results-B__headline-row">
					<p class="{$prefix}-results-heading">{$resultsI18N.deliveryRowHeading}</p>
					<p>{$resultsI18N.deliveryRowText}</p>
				</div>
				<img class="{$prefix}-results-B__image" src="{$resultsI18N.deliveryRowImage}" />
			{/if}
		</div>
	</div>
</div>

<style type="text/scss">
	@import './sass/vars';
	$region-margin: $default-margin*3;
	$heading-margin: $default-margin*2;
	$region-padding: 4rem;

	.#{$prefix}-step-page {
		@extend .step-page-styles;
	}

	.#{$prefix}-animation-container {
		position: relative;
	}
	.#{$prefix}-results-container {
		:global(h1) {
			margin: 0;
		}
	}

	.#{$prefix}-results-heading {
		font-size: 2rem;
	}

	.#{$prefix}-results-button {
		flex-grow: 0;
	}


	.#{$prefix}-results-A {
		padding: $region-padding $region-padding 0;
		margin-bottom: $region-margin;
		@media only screen and (max-width: $breakpoint-medium) {
			padding: $region-padding $default-margin 0;
		}		


		&__headline-row {
			display: flex;
			flex-flow: row wrap;
			justify-content: space-between;
			margin-bottom: $heading-margin;
		}

		&__description {
			margin-bottom: $heading-margin;
		}
		&__packs {
			display: flex;
			flex-flow: row wrap;
			justify-content: space-around;
		}

		&__pack {
			position: relative;
			display: flex;
			flex-flow: column wrap;
			align-items: center;
			width: 22.5%;

			@media only screen and (max-width: $breakpoint-large) {
				width: 48.5%;
				&:nth-child(1), &:nth-child(2) {
					margin-bottom: $region-margin;
				}
			}


			&__img {
				width: 100%;
				margin-bottom: $default-margin;
				@media only screen and (max-width: $breakpoint-medium) {
					width: 85%;
				}

			}
			&__text {
				font-weight: bold;
			}
		}
	}

	.#{$prefix}-results-B {
		padding: $region-padding;
		background-color: white;
		display: flex;
		flex-flow: column wrap;
		flex-flow: row wrap;
		justify-content: space-between;
		position: relative;
	
		@media only screen and (max-width: $breakpoint-medium) {
			padding: $region-padding $default-margin;
		}		

		&__headline-row {
			padding-right: $heading-margin;
			margin-bottom: $heading-margin;
			width: 50%;
			@media only screen and (max-width: $breakpoint-large) {
				width: 100%;
			}

		}
		&__image {
			min-width: 30%;
			width: auto;
			height: auto;
			@media only screen and (max-width: $breakpoint-large) {
				min-width: 70%;
			}

			@media only screen and (min-width: $breakpoint-large) {
				max-width: 48%;
			}

		}
	}

	.#{$prefix}-results-C {
		padding: $region-padding;
		display: flex;
		position: relative;
		flex-flow: row;

		@media only screen and (max-width: $breakpoint-medium) {
			padding: $region-padding $default-margin;
		}		

		@media only screen and (max-width: $breakpoint-large) {
			flex-flow: column wrap;
		}
	

		&__group {
			display: flex;
			flex-flow: row wrap;

			@media only screen and (max-width: $breakpoint-large) {
				flex-flow: column wrap;
				margin-bottom: $region-margin;
			}


			&__heading {
				display: flex;
				flex-flow: column wrap;
				margin-right: $heading-margin;
				margin-bottom: $heading-margin;
			}
			&__description {
				padding-right: $default-margin;

			}

			&--left {
				@media only screen and (min-width: $breakpoint-large) {
					padding-right: $region-margin;
				}

			}

			&--right {
				@media only screen and (min-width: $breakpoint-large) {
					padding-left: $region-margin;
				}
			}

		}

		&__S {			
			font-size: 1.125rem;
		}
		&__M {
			font-weight: bold;
			font-size: 1.125rem;
			
		}
		&__L {
			font-size: 2rem;
			font-weight: bold;

		}

	}

	.#{$prefix}-results-D {
		padding: $region-padding;

		@media only screen and (max-width: $breakpoint-medium) {
			padding: $region-padding $default-margin;
		}		

		background-color: white;
		&__img {
			margin-top: $heading-margin;
			@media only screen and (min-width: $breakpoint-large) {
				width: 50%;
			}		

		}
	}

</style>
